import { useContext } from 'react';
import { UserContext } from '../context';
import { useSignInDialog } from './dialog';

export const useGuestToSignIn = () => {
  const currentUser = useContext(UserContext);
  const { loadDialog } = useSignInDialog();
  const isGuest = currentUser.id === '0';

  const redirectToSignIn = (): boolean => {
    if (isGuest) {
      loadDialog(`user/signinform?returnTo=${btoa(window.location.href)}`);
    }
    return isGuest;
  };

  return { redirectToSignIn };
};
